import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import wellnessMediaArticle from "../fragments/WellnessMediaArticle"

const query = gql`
  query WellnessMediaList(
    $offset: Int
    $limit: Int
    $categoryId: ID
    $tags: [String]
  ) {
    wellnessMediaList(
      offset: $offset
      limit: $limit
      categoryId: $categoryId
      tags: $tags
    ) {
      results {
        ...wellnessMediaArticle
      }
      total
      offset
      limit
      count
    }
  }
  ${wellnessMediaArticle}
`

export const wellnessMediaListQueryKey = getQueryNames(query)[0]

export default query
